// extracted by css-extract-rspack-plugin
export default {"footerContainer":"Footer_footerContainer__uiD1u","footerText":"Footer_footerText__xcBpF","dot":"Footer_dot__9L9fd","legal":"Footer_legal__uAzu6"};